export default __webpack_public_path__ + "static/media/Egresados3.49fe09cb.png";